import React from 'react'
import Skeleton from 'react-loading-skeleton'
import classnames from 'classnames'

import PageSection from '../../../../../features/components/PageSection'

import usePanelsStyles from './styles'
import useStyles from './styles'

const SroiInfoPanelsSkeleton = () => {
  const classes = useStyles()

  const panelsClasses = usePanelsStyles()

  return (
    <div className={classes.container}>
      <PageSection className={classnames(panelsClasses.panel)}>
        <div className={classes.leftSide}>
          <Skeleton width={140} height={26} style={{ marginBottom: '8px' }} count={7} />
        </div>
        <div className={classes.rightSide}>
          <Skeleton width={140} height={26} style={{ marginBottom: '8px' }} count={5} />
        </div>
      </PageSection>
      <PageSection className={classnames(panelsClasses.panel)}>
        <div className={classes.leftSide}>
          <Skeleton width={140} height={26} style={{ marginBottom: '8px' }} count={3} />
        </div>
        <div className={classes.rightSide}>
          <Skeleton width={140} height={26} style={{ marginBottom: '8px' }} count={3} />
        </div>
      </PageSection>
      <PageSection className={classnames(panelsClasses.panel)}>
        <div className={classes.leftSide}>
          <Skeleton width={140} height={26} style={{ marginBottom: '8px' }} count={4} />
        </div>
        <div className={classes.rightSide}>
          <Skeleton width={140} height={26} style={{ marginBottom: '8px' }} count={4} />
        </div>
      </PageSection>
    </div>
  )
}

export default SroiInfoPanelsSkeleton
